import { useUserEventLogger } from '@repo/tracking-service';
import { Accordion, AccordionButton, AccordionContent, AccordionItem, AccordionTrigger, MainTitle } from '@repo/ui';

import { FAQ_CATEGORIES, FAQ_CONTENTS } from '@/lib/constants/help';

export const FaqContent = ({ selectedCategory }: { selectedCategory: string }) => {
  const { sendClickEvent } = useUserEventLogger();
  return (
    <div className={'flex flex-col gap-3 bg-gray-100'}>
      {Array.from(FAQ_CATEGORIES.keys()).map((categoryKey) => {
        return (
          categoryKey !== 'all' &&
          (selectedCategory === 'all' || selectedCategory === categoryKey) && (
            <div key={`${selectedCategory}-${categoryKey}`} className="page-padding bg-white pb-8 pt-4">
              <MainTitle title={FAQ_CATEGORIES.get(categoryKey) ?? ''} size="small" />
              <Accordion type="multiple" className="w-full">
                {FAQ_CONTENTS[categoryKey]?.map((content, index, array) => (
                  <AccordionItem key={index} value={content.title}>
                    <AccordionTrigger
                      className="!px-0 py-normal-small hover:no-underline font-semibold [&>svg]:w-[18px] [&>svg]:h-[18px] [&>svg]:text-neutral-foreground-lowest"
                      onClick={() => {
                        sendClickEvent(`faq_body_accordion-${selectedCategory}`, { item: content.title });
                      }}
                    >
                      <div className={'text-left w-full'}>{content.title}</div>
                      <AccordionButton type={'chevron-down'} size={18} color={'#8A96A3'} />
                    </AccordionTrigger>
                    <div className="-mx-3">
                      <AccordionContent
                        className={`py-4 px-3 rounded-2xl bg-neutral-background-lowest caption-medium-regular text-neutral-foreground-low !pb-normal-medium ${index === array.length - 1 ? '' : 'mb-[12px]'}`}
                      >
                        {content.content}
                      </AccordionContent>
                    </div>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          )
        );
      })}
    </div>
  );
};
